import { useSelector } from 'react-redux'
import { wrestlers as rawFixtures } from '@fedsim/imports'
import { getModeledWrestlers as getStoreItems, sortByPoints } from 'selectors'
import { mapImported, modelDefaultValues } from '../helpers'

import Form from './form'

export const useWrestlers = () => {
  const rawImported: any[] = useSelector(getStoreItems)
  const imported = rawImported.map(model => modelDefaultValues(Form, model)).sort(sortByPoints)
  const fixtures = rawFixtures.map(model => modelDefaultValues(Form, model)).sort(sortByPoints)
  const mapped = mapImported(fixtures, imported)
  const notImported = mapped.filter(item => item.imported === false).sort(sortByPoints)

  return {
    mapped,
    fixtures,
    imported,
    notImported
  }
}
